import React from "react";
import Select from "react-select";

const DAY_COLORS = ["#cfe2ff", "#d1e7dd", "#fff3cd", "#f8d7da", "#e9d8fd"];
const DAY_TEXT_COLORS = ["#084298", "#0a3622", "#664d03", "#842029", "#4a0e5c"];

const selectStyles = {
    control: (base) => ({
        ...base,
        minHeight: "34px",
        fontSize: "0.75rem",
        borderColor: "#ced4da",
        minWidth: 130,
    }),
    menu: (base) => ({ ...base, zIndex: 9999, fontSize: "0.75rem" }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? "#6418c3"
            : state.isFocused
                ? "rgba(100,24,195,.08)"
                : "white",
        color: state.isSelected ? "#fff" : "#212529",
    }),
};

const NavBtn = ({ icon, onClick }) => (
    <button
        className="btn btn-sm btn-outline-secondary"
        onClick={onClick}
        style={{
            borderRadius: "50%",
            width: 28,
            height: 28,
            padding: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}
    >
        <i className={`fa fa-chevron-${icon}`} style={{ fontSize: 10 }} />
    </button>
);

const TH = ({ children, style = {} }) => (
    <th
        style={{
            fontSize: 12,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            color: "#6c757d",
            ...style,
        }}
    >
        {children}
    </th>
);

const ListViewTable = ({
    data,
    days,
    dateRange,
    onPrev,
    onNext,
    clientOptions,
    projectOptions,
    selectedClient,
    onClientChange,
    selectedProject,
    onProjectChange,
    isEmployee,
    onEdit,
    onViewComment,
    onDelete,
    onAddComment,
}) => (
    <div className="mt-4 pt-3 border-top">
        <h5 style={{ fontWeight: 700, fontSize: 16, marginBottom: 16 }}>List View</h5>

        {/* Controls */}
        <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
            background: "#fff",
            borderRadius: 12,
            padding: "14px 20px",
            marginBottom: 16,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            border: "1px solid #e2e8f0",
        }}>
            {/* Date nav */}
            <div className="d-flex align-items-center gap-2">
                <div className="d-flex align-items-center gap-2">
                    <button
                        onClick={onPrev}
                        style={{
                            width: 30,
                            height: 30,
                            borderRadius: "50%",
                            border: "1px solid #e2e8f0",
                            background: "#fff",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#475569",
                            fontSize: 12,
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                    >
                        <i className="fa fa-chevron-left" />
                    </button>
                    {/* <NavBtn icon="left" onClick={onPrev} /> */}
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <i className="fa fa-calendar text-muted" style={{ color: "#94a3b8", fontSize: 13 }} />
                        <span style={{ fontSize: 14, fontWeight: 600, color: "#334155", whiteSpace: "nowrap" }}>{dateRange}</span>
                    </div>
                    {/* <NavBtn icon="right" onClick={onNext} /> */}
                    <button
                        onClick={onNext}
                        style={{
                            width: 30,
                            height: 30,
                            borderRadius: "50%",
                            border: "1px solid #e2e8f0",
                            background: "#fff",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#475569",
                            fontSize: 12,
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                    >
                        <i className="fa fa-chevron-right" />
                    </button>
                </div>
            </div>

            {/* Filters + Add Comments */}
            <div className="d-flex gap-2 align-items-center flex-wrap">
                <Select
                    options={clientOptions}
                    value={selectedClient || clientOptions[0]}
                    onChange={(opt) => onClientChange(opt?.value ? opt : null)}
                    styles={selectStyles}
                    placeholder="Select Client"
                    isClearable={false}
                />
                <Select
                    options={projectOptions}
                    value={selectedProject || projectOptions[0]}
                    onChange={(opt) => onProjectChange(opt?.value ? opt : null)}
                    styles={selectStyles}
                    placeholder="Select Project"
                    isClearable={false}
                />

            </div>
        </div>

        {/* Table */}
        <div style={{ display: "flex", alignItems: "stretch", gap: 0 }}>
            <div style={{
                flex: 1, overflowX: "auto",
                borderRadius: 12, border: "1px solid #e2e8f0",
                background: "#fff", boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            }}>
                <table className="table table-striped align-middle mb-0">
                    <thead>
                        <tr>
                            <TH>Client</TH>
                            <TH>Project</TH>
                            <TH style={{ minWidth: 190 }}>
                                {days[0]?.date} – {days[4]?.date}
                            </TH>
                            <TH style={{ minWidth: 200 }}>Task</TH>
                            <TH style={{ minWidth: 200 }}>Comments</TH>
                            <TH style={{ textAlign: "center", width: 90 }}>Actions</TH>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length === 0 ? (
                            <tr>
                                <td colSpan={6} className="text-center py-5 text-muted">
                                    <i className="fa fa-calendar-o fa-2x mb-2 opacity-50 d-block" />
                                    No records match your filters.
                                </td>
                            </tr>
                        ) : (
                            data.map((row) => (
                                <tr key={row.id}>
                                    <td style={{ fontSize: 13, fontWeight: 600 }}>{row.client}</td>
                                    <td style={{ fontSize: 13 }}>{row.project}</td>

                                    {/* Day badges */}
                                    <td>
                                        <div className="d-flex gap-1 flex-wrap">
                                            {days.map((d, i) => (
                                                <span
                                                    key={d.short}
                                                    style={{
                                                        background: row.days[i] ? DAY_COLORS[i] : "#f0f0f0",
                                                        color: row.days[i] ? DAY_TEXT_COLORS[i] : "#adb5bd",
                                                        fontSize: 10,
                                                        fontWeight: 700,
                                                        padding: "2px 7px",
                                                        borderRadius: 4,
                                                    }}
                                                >
                                                    {d.short}
                                                </span>
                                            ))}
                                        </div>
                                    </td>

                                    {/* Task */}
                                    <td
                                        style={{
                                            fontSize: 12,
                                            color: "#6c757d",
                                            maxWidth: 200,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                        title={row.task}
                                    >
                                        {row.task}
                                    </td>

                                    {/* User Comment */}
                                    <td
                                        onClick={() => !isEmployee && onViewComment && onViewComment(row)}
                                        style={{
                                            fontSize: 12,
                                            color: row.userComment ? "#334155" : "#adb5bd",
                                            maxWidth: 200,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            fontStyle: row.userComment ? "normal" : "italic",
                                            cursor: !isEmployee ? "pointer" : "default",
                                            textDecoration: (!isEmployee && row.userComment) ? "underline dotted" : "none",
                                        }}
                                        title={!isEmployee ? (row.userComment || "No comment yet") : undefined}
                                    >
                                        {row.userComment || "—"}
                                    </td>

                                    {/* Actions */}
                                    <td className="text-center" style={{ whiteSpace: "nowrap" }}>
                                        {isEmployee ? (
                                            <button
                                                className="btn btn-info shadow btn-xs sharp me-1"
                                                title="Comment"
                                                onClick={() => onEdit(row)}
                                            >
                                                <i className="fa fa-comment" />
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-primary shadow btn-xs sharp me-1"
                                                title="Edit"
                                                onClick={() => onEdit(row)}
                                            >
                                                <i className="fas fa-pencil-alt" />
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
);

export default ListViewTable;
